const hook = {
    missing_events: 'Musisz podać przynajmniej jedno zdarzenie.',
    send_test_payload_failed: 'Błąd podczas wysyłania testowego ładunku: {{message}}',
    endpoint_responded_with_error: 'Punkt końcowy odpowiedział błędem.',
};
export default Object.freeze(hook);
